import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {
  isFormFileUploadWrapper,
  isUserFormFileInput,
} from '@packages/utilities/elementTypeUtils';
import {findElementDescendant} from '@packages/utilities/platform';

export function isUserFormFileUploadWrapper(
  element: ExpressionElement
): boolean {
  return (
    isFormFileUploadWrapper(element) &&
    Boolean(findElementDescendant(element, isUserFormFileInput))
  );
}
